import React from "react"
import Link from "../images/components/link.svg"

const ImageButton = ({ image, link, title, subtitle, duration }) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="imageButton"
      style={{ backgroundImage: `url("${image.childImageSharp.fluid.src}")` }}
    >
      <h5 className="imageButton__title">{title}</h5>
      <h6 className="imageButton__subtitle">{subtitle}</h6>
      <div className="imageButton__informations">
        <span className="imageButton__link">
          Lire la vidéo
          <Link />
        </span>
        {duration && <span className="imageButton__duration">{duration}</span>}
      </div>
    </a>
  )
}

export default ImageButton
